type TealiumEvent = typeof window.onButtonAndLinkClicksEvent;
type TrackingData = Parameters<NonNullable<TealiumEvent>>[0];

const fireButtonAndLinkClicksEvent: (
  trackingData: TrackingData
) => void = trackingData => {
  try {
    // fire the utag link event
    if (window.onButtonAndLinkClicksEvent) {
      window.onButtonAndLinkClicksEvent(trackingData);
    }
  } catch (e) {
    console.log(
      'onButtonAndLinkClicksEvent failed - please check the Button and Link Clicks Script'
    );
  }
};

export default fireButtonAndLinkClicksEvent;
